import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.case-study-slider-block');

    blocks.forEach((block) => {
        if (!block.dataset.swiperConfig) return;

        const sliderEl = block.querySelector('.case-study-content.swiper');
        const nextPreview = block.querySelector('.next-slide-preview');
        if (!sliderEl) return;

        const slides = sliderEl.querySelectorAll('.swiper-slide');
        const thumbCache = Array.from(slides).map(slide => slide.getAttribute('data-next-thumb') || '');
        const totalSlides = thumbCache.length;

        const updateNextPreview = (realIndex) => {
            if (!nextPreview) return;
            const nextIndex = (realIndex + 1) % totalSlides;
            const nextThumbUrl = thumbCache[nextIndex];
            const nextTitle = slides[nextIndex].getAttribute('data-next-title') || 'Next slide';

            if (nextPreview.dataset.currentImg === nextThumbUrl) return;
            nextPreview.dataset.currentImg = nextThumbUrl;

            if (nextThumbUrl && nextThumbUrl.trim() !== "") {
                nextPreview.innerHTML = `<img src="${nextThumbUrl}" alt="Next slide" />`;
            } else {
                nextPreview.innerHTML = `<div class="empty-preview">${nextTitle}</div>`;
            }
        };

        const baseConfig = JSON.parse(block.dataset.swiperConfig);
        
        // Use querySelectorAll to get ALL prev/next buttons in this block
        const prevBtns = Array.from(block.querySelectorAll('.swiper-prev'));
        const nextBtns = Array.from(block.querySelectorAll('.swiper-next'));

        const instanceConfig = { 
            modules: [Navigation, Pagination, Autoplay],
            ...baseConfig,
            navigation: {
                nextEl: nextBtns, // Pass the array of elements
                prevEl: prevBtns, // Pass the array of elements
            },
            on: {
                init: (s) => updateNextPreview(s.realIndex),
                realIndexChange: (s) => updateNextPreview(s.realIndex)
            }
        };

        const swiper = new Swiper(sliderEl, instanceConfig);

        if (nextPreview) {
            nextPreview.addEventListener('click', () => swiper.slideNext());
        }
        
        /**
         * Optional: Manual override for buttons inside slides
         * If you use loop: true, Swiper clones slides. Cloned buttons 
         * often lose their connection to the Navigation module.
         */
        block.addEventListener('click', (e) => {
            if (e.target.closest('.swiper-next')) {
                swiper.slideNext();
            }
            if (e.target.closest('.swiper-prev')) {
                swiper.slidePrev();
            }
        });
    });
});